import React from 'react'
import FilterCard from '../../../components/filter-card'
import useI18n from '../../../i18n/useI18n'
import { CommonAllOption } from '../../../utils/enums'

export const commissionFilterDefaults = {
    search: '',
    city: '',
    country: '',
    has_active_contract: '',
    contract_expiring_soon: '',
    sort: 'created_at',
    order: 'DESC'
}

const CommissionsFilter = ({ filters, onFilterChange, onFilterSubmit, onClearFilters, onRefresh, loading }) => {
    const { t } = useI18n()
    const booleanOptions = [
        CommonAllOption,
        { value: 'true', label: t('AGENT_COMMISSIONS_FILTERS_YES') },
        { value: 'false', label: t('AGENT_COMMISSIONS_FILTERS_NO') }
    ]
    const sortOptions = [
        { value: 'created_at', label: t('AGENT_COMMISSIONS_FILTERS_SORT_CREATED_AT') }
    ]
    const orderOptions = [
        { value: 'ASC', label: t('AGENT_COMMISSIONS_FILTERS_ORDER_ASC') },
        { value: 'DESC', label: t('AGENT_COMMISSIONS_FILTERS_ORDER_DESC') }
    ]
    const fields = [
        {
            type: 'input',
            name: 'search',
            placeholder: t('AGENT_COMMISSIONS_SEARCH_PLACEHOLDER'),
            icon: 'zmdi zmdi-search',
            colSize: 'col-lg-4 col-md-6 col-sm-12'
        },
        {
            type: 'select',
            name: 'city',
            placeholder: t('AGENT_COMMISSIONS_FILTERS_CITY_PLACEHOLDER'),
            icon: 'zmdi zmdi-pin',
            fetchUrl: 'cities',
            prependOptions: [CommonAllOption],
            mapOption: (item) => {
                if (!item) return null
                const label = item.cityName || item.name || item.label
                if (!label) return null
                return {
                    value: label.toString(),
                    label: label.toString()
                }
            },
            colSize: 'col-lg-4 col-md-6 col-sm-12'
        },
        {
            type: 'input',
            name: 'country',
            placeholder: t('AGENT_COMMISSIONS_FILTERS_COUNTRY_PLACEHOLDER'),
            icon: 'zmdi zmdi-globe-alt',
            colSize: 'col-lg-4 col-md-6 col-sm-12'
        },
        {
            type: 'select',
            name: 'has_active_contract',
            placeholder: t('AGENT_COMMISSIONS_FILTERS_HAS_ACTIVE_CONTRACT_PLACEHOLDER'),
            icon: 'zmdi zmdi-check-circle',
            options: booleanOptions,
            colSize: 'col-lg-4 col-md-6 col-sm-12'
        },
        {
            type: 'select',
            name: 'contract_expiring_soon',
            placeholder: t('AGENT_COMMISSIONS_FILTERS_CONTRACT_EXPIRING_SOON_PLACEHOLDER'),
            icon: 'zmdi zmdi-time',
            options: booleanOptions,
            colSize: 'col-lg-4 col-md-6 col-sm-12'
        }
    ]

    return (
        <FilterCard
            filters={filters}
            onFilterChange={onFilterChange}
            onFilterSubmit={onFilterSubmit}
            onClearFilters={onClearFilters}
            onRefresh={onRefresh}
            loading={loading}
            title="AGENT_COMMISSIONS_FILTERS_TITLE"
            titleHide="COMMON_FILTERS"
            titleShow="COMMON_FILTERS"
            fields={fields}
            defaultFilters={commissionFilterDefaults}
            defaultOpen={true}
        />
    )
}

export default CommissionsFilter
